import React from 'react';
import { Briefcase, Globe, AlertTriangle, Search } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

export const BrandProtectionFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Brand Protection"
      description="Protect your brand from online threats, impersonation, and infringements with comprehensive monitoring and enforcement."
      icon={<Briefcase className="h-8 w-8 text-blue-600" />}
      featureName="brand-protection"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Globe className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Domain Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor for lookalike domains, typosquatting, and other domain-based brand impersonation attempts.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertTriangle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Infringement Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify unauthorized use of your brand, logos, and trademarks across the web and marketplaces.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Social Media Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor social media platforms for brand impersonation, fake accounts, and unauthorized content.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Briefcase className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Enforcement Actions</h3>
          </div>
          <p className="text-gray-400">
            Take action against brand violations with automated takedown requests and enforcement workflows.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
